import { render, staticRenderFns } from "./MyPrivacy.vue?vue&type=template&id=63af3798&scoped=true"
import script from "./MyPrivacy.vue?vue&type=script&lang=js"
export * from "./MyPrivacy.vue?vue&type=script&lang=js"
import style0 from "./MyPrivacy.vue?vue&type=style&index=0&id=63af3798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af3798",
  null
  
)

export default component.exports